<template>
	<div
		class="search-container"
		:class="focus ? 'focused' : 'nfocused ' + stylesClass"
		:style="'height:' + height + '; width:' + width + ';'"
	>
		<input
			id="searchinput"
			v-model="searchtext"
			v-debounce:0="sendData"
			type="search"
			:class="`search-input ${bordered ? 'bordered' : ''}`"
			placeholder="Pesquisar..."
			@focus="focusinput(true)"
			@blur="focusinput(false)"
		/>
		<label for="searchinput" class="search-icon-container" @click="sendData">
			<feather class="search-icon" type="search" stroke-width="3" size="16" />
		</label>
	</div>
</template>

<script>
export default {
	props: {
		width: {
			type: String,
			default: '50px',
		},
		height: {
			type: String,
			default: '30px',
		},
		borderRadius: {
			type: String,
			default: '3px',
		},
		bordered: {
			type: Boolean,
			default: false,
		},
		stylesClass: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			focus: false,
			searchtext: '',
		};
	},
	methods: {
		focusinput(focus) {
			this.focus = focus;
		},
		styles() {},
		sendData() {
			this.$emit('searchtext', this.searchtext);
		},
	},
};
</script>

<style scoped>
.focused {
	background-color: #fff;
}
.nfocused {
	background-color: #fff;
}
.search-container {
	display: flex;
	align-items: center;
	border-radius: 5px;
	transition: 0.3s ease-in;
}

.search-container label {
	cursor: pointer !important;
	all: unset;
	height: 100%;
	width: 12%;
	margin: 0;
	justify-content: center;
	align-items: center;
	display: flex;
	background-color: #09af5f;
	border-top-right-radius: 5px;
	border-bottom-right-radius: 5px;
}
.search-input {
	all: unset;
	width: 100%;
	height: 100%;
	padding: 0;
}

.bordered {
	border: 1px solid #ccc;
	box-sizing: border-box;
	padding-left: 9px;
}

.search-input::placeholder {
	font-size: 13px;
}

.search-icon {
	color: #fff;
	padding: 5px;
}
</style>
